import { IAiOfficePluginApi, IRegisteredSlotComProps } from './api';
import { createPluginCtx, PluginCtxTools } from './react';
import { IPluginManifest, PluginID, SlotName } from './types';

export interface IAiOfficePlugin {
  readonly id: PluginID;

  onInstall?: (api: IAiOfficePluginApi) => void | Promise<void>;

  onDestroy?: () => void | Promise<void>;

  getManifest?: () => IPluginManifest | Promise<IPluginManifest>;
}

export abstract class BaseAiOfficePlugin<T = {}> implements IAiOfficePlugin {
  readonly id: PluginID;

  protected ctxUtils!: PluginCtxTools<T>;

  protected api!: IAiOfficePluginApi;

  constructor(id: PluginID) {
    this.id = id;
  }

  registerSlot(
    slotName: SlotName,
    component: React.ComponentType<IRegisteredSlotComProps>,
    matcher?: (payload: unknown) => boolean
  ) {
    const useStore = this.useStore ?? (() => ({}) as T);

    this.api.ui.registerSlot(
      slotName,
      this.ctxUtils.withCtx(useStore, component),
      this.id,
      this.weight,
      matcher
    );
  }

  // registerStyledSlot(
  //   slotName: SlotName,
  //   component: React.ComponentType<IRegisteredSlotComProps>,
  //   style?: string
  // ) {
  //   const useStore = this.useStore ?? (() => ({}) as T);

  //   const styledComponent = withStyle(component, style);

  //   const scopedCom = this.ctxUtils.withCtx(useStore, styledComponent);

  //   this.api.ui.registerSlot(slotName, scopedCom, this.id, this.weight);
  // }

  registerShadowSlot(
    slotName: SlotName,
    component: React.ComponentType<IRegisteredSlotComProps>,
    style?: string,
    matcher?: (payload: unknown) => boolean
  ) {
    const useStore = this.useStore ?? (() => ({}) as T);

    const scopedCom = this.ctxUtils.withCtx(useStore, component);

    this.api.ui.registerSlot(slotName, scopedCom, this.id, this.weight, matcher, {
      shadow: true,
      style,
    });
  }

  onInstall(api: IAiOfficePluginApi): void | Promise<void> {
    this.ctxUtils = createPluginCtx(api);
    this.api = api;
  }

  abstract weight?: number;

  abstract useStore?: () => T;

  onDestroy(): void | Promise<void> {
    console.log(`Destroying plugin ${this.id} in base abstract class`);

    this.ctxUtils = null as never;

    const previewerService = this.api.service.get('previewerService');
    if (previewerService) {
      console.log('Plugin onDestroy: resetting previewerService state');
      previewerService.reset();
    }
  }
}
